<template>
  <div class="param-search">
    <app-loader v-if="loading && getMovies.page === 1" />

    <app-page-title v-if="getMovies.movies.length !== 0">
      Suchergebnis:
    </app-page-title>

    <app-card
      v-if="getMovies.movies.length !== 0"
      :items="getMovies"
    />

    <app-fail-message v-if="getMovies.totalRes === 0">
      Wos suachsd na du für a zeig. Hamma ned!
    </app-fail-message>

    <v-container v-if="getMovies.pages !== getMovies.page && getMovies.movies.length !== 0">
      <v-layout row>
        <v-flex>
          <div class="text-xs-center">
            <v-btn
              flat
              :loading="loading"
              @click="loadMore"
            >
              Mehr bitte!
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// FIXME: Bilder werden nicht sofort angezeigt nach klick auf einen Genre-Button (aus FilmDetail)
import { mapState } from 'vuex';
import PageTitle from '../components/PageTitle.vue';
import MovieCard from '../components/MovieCard.vue';
import FailMessage from '../components/FailMessage.vue';

export default {
  name: 'ParamSearch',

  components: {
    appPageTitle: PageTitle,
    appFailMessage: FailMessage,
    appCard: MovieCard,
  },
  computed: {
    ...mapState({
      getMovies(state) {
        return state.paramSearch.paramsData;
      },
    }),
    loading() {
      return this.$store.getters.loading;
    },
  },
  methods: {
    loadMore() {
      this.$store.dispatch('getParamResults', { params: this.getMovies.params });
    },
  },

};
</script>
